import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

/*Reorganizados*/

/* Metodos Principales */
export const visionStartRegisterAdmin = (vision, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_VISION}`,
      "add",
      vision,
      "POST"
    );

    const body = await resp.json();

    debugLogActions(':: visionActions, visionStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const visionSaved = body.vision || body.visionObject || {};

      dispatch(visionRegisterAdmin(visionSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-vision";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const visionRegisterAdmin = (vision) => ({
  type: types.VISION_START_REGISTER_ADMIN,
  payload: vision,
});

export const visionStartUpdate = (vision, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_VISION}`,
        `update/${vision.id}`,
        vision,
        "PUT"
      );
      const body = await resp.json();

      debugLogActions(':: visionActions, visionStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(visionUpdated(vision));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: visionActions, visionStartUpdate', { 'error': error });
    }
  };
};

const visionUpdated = (vision) => {
  return {
    type: types.VISION_UPDATE,
    payload: vision,
  };
};

export const visionStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_VISION}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

              debugLogActions(':: visionActions, visionStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(visionDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: visionActions, visionStartDelete', { 'error': error });
    }
  };
};

const visionDeleted = (id) => {
  return {
    type: types.VISION_DELETE,
    payload: id,
  };
};

const mergeVisionConcernFilter = (catalogToFilter, concern) => {
  const filters = Array.isArray(catalogToFilter) ? catalogToFilter : [];
  const withoutConcern = filters.filter((item) => !item || !Object.prototype.hasOwnProperty.call(item, 'catalogconcern_id'));
  const concernId = concern && concern.id ? Number(concern.id) : 0;
  if (!concernId) return withoutConcern;
  return [...withoutConcern, { catalogconcern_id: concernId }];
};

export const startLoadingVisionsPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'vision');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_VISION}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

    debugLogActions(':: visionActions, startLoadingVisionsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingVisionsPaginated(body.visionsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingVisionsPaginated = (visionsPaginated) => ({
  type: types.VISION_START_LOADING_PAGINATED,
  payload: visionsPaginated,
});

export const startLoadingVisionsByTextVisionPaginated = (vision, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {
    const concern = getState().searchHistory?.concern;
    const searchFilters = mergeVisionConcernFilter(catalogToFilter, concern);

       const searchInfo = {
      searchVisionText: vision,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: searchFilters,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(visionIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_VISION}`,
      `getByTextVision/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

    debugLogActions(':: visionActions, startLoadingVisionsByTextVisionPaginated', { 'body': body });

    if (body.ok) {

      dispatch(visionIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.visionsPaginated.visionsP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingVisionsByTextVisionPaginated(body.visionsPaginated));

      const { totalItems, totalPages, currentPage, visionsP } = body.visionsPaginated;
      
            let index = 0;
            let registerIds = "";
            visionsP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(visionIsLoadingFinish());

      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

export const startLoadingVisionsByTextVisionPaginatedNoCiiu = (vision, page, size, catalogToFilter, indicatorToFilter = []) => {
  return async (dispatch, getState) => {
    const concern = getState().searchHistory?.concern;
    const searchFilters = mergeVisionConcernFilter(catalogToFilter, concern);

    //console.log("TT4, startLoadingVisionsByTextVisionPaginatedNoCiiu");

       const searchInfo = {
      searchVisionText: vision,
      //codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: searchFilters,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(visionIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_VISION}`,
      `getByTextVision/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

    debugLogActions(':: visionActions, startLoadingVisionsByTextVisionPaginated', { 'body': body });

    if (body.ok) {

      dispatch(visionIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.visionsPaginated.visionsP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingVisionsByTextVisionPaginated(body.visionsPaginated));

      const { totalItems, totalPages, currentPage, visionsP } = body.visionsPaginated;
      
            let index = 0;
            let registerIds = "";
            visionsP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {
      
      dispatch(visionIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingVisionsByTextVisionPaginated = (visionsPaginated) => ({
  type: types.VISION_START_LOADING_VISION_PAGINATED,
  payload: visionsPaginated,
});

export const startSearchingVisionsPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'vision');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_VISION}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

    debugLogActions(':: visionActions, startSearchingVisionsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingVisionsPaginated(body.visionsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingVisionsPaginated = (visionsPaginated) => ({
  type: types.VISION_START_SEARCH_PAGINATED,
  payload: visionsPaginated,
});

export const selectVision = (vision) => ({
  type: types.VISION_SELECT,
  payload: vision,
});

export const cleanVisionsPaginatedS = () => ({
  type: types.VISION_CLEAN_SEARCH_PAGINATED,
});

export const cleanVisionsPaginatedP = () => ({
  type: types.VISION_CLEAN_PAGINATED,
});

export const visionSetSearchText = (searchText) => ({
  type: types.VISION_SET_SEARCH_TEXT,
  payload: searchText,
});

export const visionCleanSearchText = () => ({
  type: types.VISION_CLEAN_SEARCH_TEXT,
});

export const visionCleanSaved = () => ({
  type: types.VISION_CLEAN_SAVED,
});

//Si van 13 de Feb 2026
export const visionListUpdateSelected = (id) => ({
  type: types.VISION_LIST_UPDATE_SELECTED,
  payload: id
});

export const visionListSelectAllLimit = () => ({
  type: types.VISION_SELECT_ALL_LIMIT,
});

export const visionCleanAllSelected = () => ({
  type: types.VISION_CLEAN_ALL_SELECTED,
});

export const visionIsLoading = () => ({
  type: types.VISION_IS_LOADING
});

export const visionIsLoadingFinish = () => ({
  type: types.VISION_IS_LOADING_FINISH
});

//No van 13 de Feb 2026

export const visionGetMoreThanOneIsSelected = () => ({
  type: types.VISION_GET_MORE_THAN_ONE_SELECTED
});

export const visionGetNumberVisionSelected = (countCompareFlag) => ({
  type: types.VISION_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.VISION_CLEAN_SEARCH_INFORMATION,
});